import styles from './styles.module.css';

const NewReferenceItems = ({ items, spodoptera, square }) => {
    if (!items || !items.length) return null;

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${items.length}, 1fr)`,
                ...(items.length > 3 && {
                    display: 'flex',
                    flexWrap: 'wrap',
                }),
                ...(square && {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '5px',
                }),
                ...(spodoptera && {
                    gridTemplateColumns: `repeat(1, 1fr)`,
                }),
            }}
        >
            {items.map((item) => (
                <div
                    key={item.value}
                    style={{
                        width: '100%',
                        ...(square && {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            width: '100px',
                        }),
                        ...(items.length > 6 && {
                            width: '100px',
                        }),
                    }}
                >
                    <div
                        className={styles.item}
                        style={{
                            background: `#${item.color}`,
                            borderRadius: '7px',
                            ...(square && {
                                display: 'flex',
                                flexWrap: 'wrap',
                                minWidth: '50px',
                                height: '50px',
                            }),
                        }}
                    >
                        {!square && item.value}
                    </div>
                    {square && item.value}
                </div>
            ))}
        </div>
    );
};

export default NewReferenceItems;
